var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "dollar-sign"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector ",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.5 0.125C6.70711 0.125 6.875 0.292893 6.875 0.5V2.12502H9C9.20711 2.12502 9.375 2.29291 9.375 2.50002C9.375 2.70712 9.20711 2.87502 9 2.87502H6.875V5.62502H7.75C8.31359 5.62502 8.85409 5.8489 9.2526 6.24742C9.65112 6.64593 9.875 7.18643 9.875 7.75002C9.875 8.3136 9.65112 8.8541 9.2526 9.25262C8.85409 9.65113 8.31358 9.87502 7.75 9.87502H6.875V11.5C6.875 11.7071 6.70711 11.875 6.5 11.875C6.29289 11.875 6.125 11.7071 6.125 11.5V9.87502H3.5C3.29289 9.87502 3.125 9.70712 3.125 9.50002C3.125 9.29291 3.29289 9.12502 3.5 9.12502H6.125V6.37502H5.25C4.68641 6.37502 4.14591 6.15113 3.7474 5.75262C3.34888 5.3541 3.125 4.8136 3.125 4.25002C3.125 3.68643 3.34888 3.14593 3.7474 2.74741C4.14591 2.3489 4.68641 2.12502 5.25 2.12502H6.125V0.5C6.125 0.292893 6.29289 0.125 6.5 0.125ZM6.125 2.87502H5.25C4.88533 2.87502 4.53559 3.01988 4.27773 3.27774C4.01987 3.53561 3.875 3.88534 3.875 4.25002C3.875 4.61469 4.01987 4.96443 4.27773 5.22229C4.53559 5.48015 4.88533 5.62502 5.25 5.62502H6.125V2.87502ZM6.875 6.37502V9.12502H7.75C8.11467 9.12502 8.46441 8.98015 8.72227 8.72229C8.98013 8.46443 9.125 8.11469 9.125 7.75002C9.125 7.38534 8.98013 7.03561 8.72227 6.77774C8.46441 6.51988 8.11467 6.37502 7.75 6.37502H6.875Z",
  fill: "#00538F"
}));

function SvgDollarSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar-sign.7d0f977e.svg";
export { ForwardRef as ReactComponent };